<template>
    <v-container v-if="can('api.v1.search.index')" class="mx-0 mr-4 px-0 d-flex align-items-center search-bar expanded">
        <v-text-field
            v-model="query"
            :label="t('search::form.label.search')"
            class="search-bar-input"
            background-color="#fff"
            dense
            hide-details
            outlined
            rounded
            :append-icon="showResults ? 'mdi-close' : 'mdi-magnify'"
            @click:append="showResults ? closeResultWrap() : false"
        >
        </v-text-field>
        <div v-show="showResults" class="search-bar-result">
            <div class="search-bar-result-wrap">
                <div v-if="loading" class="pt-3 d-flex align-center justify-center">
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                </div>
                <div v-else>
                    <div v-if="result.data && result.data.length">
                        <div v-if="can('search.index')" class="search-bar-result-wrap-meta">
                            <div>
                                <strong>{{ result.data.length }} </strong>
                                {{ t('search::search.label.of') }}
                                <strong> {{ result.meta.pagination.total_items }} </strong>
                                {{ t('search::search.label.total') }}
                            </div>
                            <v-btn
                                text
                                rounded
                                small
                                class="px-2"
                                color="primary"
                                @click="$root.goTo(showAllResultLink())"
                                >{{ t('search::button.view_all_results') }}
                            </v-btn>
                        </div>
                        <div class="search-bar-result-wrap-copy">
                            <div v-for="(item, index) in result.data" :key="index">
                                <component
                                    :is="`search-bar-item-${item.type}`"
                                    :is-grid="false"
                                    :item="item"
                                    :query="query"
                                ></component>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="p-0 m-0 text-center" v-text="t('search::nothing_found')"></p>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            query: null,
            expanded: true,
            loading: false,
            result: {
                data: [],
                meta: {
                    pagination: {
                        total_items: 0,
                        total_pages: 0,
                        current_page: 0,
                        per_page: 0,
                    },
                },
            },
            showResults: false,
            cancelSource: null,
        };
    },
    watch: {
        expanded(expanded) {
            this.setSearchBarClasses(expanded);
        },
        query(newString, oldString) {
            const newQuery = _.trim(newString);
            const oldQuery = _.trim(oldString);
            if (newQuery == oldQuery) return;
            if (!newQuery || newQuery.length < 3) return;
            if (!this.showResults) {
                this.showResults = true;
            }
            this.search(newQuery);
        },
        showResults(value) {
            this.$root.overlay = value;
        },
    },
    methods: {
        expandSearchBar() {
            if (!this.expanded) {
                this.expanded = true;
                return;
            }
            if (this.can('search.index') && this.result.data.length) {
                return this.$root.goTo(route('search.index'));
            }
        },
        setSearchBarClasses(expanded) {
            const searchBar = this.$el;
            if (!searchBar) {
                return;
            }
            expanded ? searchBar.classList.add('expanded') : searchBar.classList.remove('expanded');
        },
        closeResultWrap() {
            this.showResults = false;
            this.query = '';
        },
        search: _.debounce(function (query) {
            if (this.loading && this.cancelSource) {
                this.cancelSource.cancel('Another request to be sent');
            }

            this.loading = true;

            this.cancelSource = axios.CancelToken.source();

            axios
                .get(
                    route('api.v1.search.index', {
                        query,
                        limit: 10,
                    }),
                    {
                        cancelToken: this.cancelSource.token,
                    }
                )
                .then((response) => {
                    this.result = _.clone(response.data);
                    this.loading = false;
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        //nothing here - another request is sent
                        return;
                    }
                    this.$root.notify('error', error.response.data.error);
                    this.loading = false;
                });
        }, 300),
        showAllResultLink() {
            return route('search.index', {
                query: this.query,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.search-bar {
    position: relative;

    &-input {
        transition: 0.2s width ease-in-out;
        padding-top: 0 !important;

        .v-input__control {
            .v-input__slot {
                padding: 0;

                fieldset {
                    padding: 0;
                    border-color: transparent;
                }

                .v-text-field__slot {
                    display: none;

                    .v-label--active {
                        transform: translateY(-16px) scale(0.75);
                        background: #fff;
                        padding: 0 10px;
                    }
                }
            }
        }
    }

    &.expanded {
        .search-bar-input {
            width: 260px;
            position: relative;
            z-index: 9;

            .v-input__control {
                .v-input__slot {
                    padding: 0 14px;

                    fieldset {
                        padding: 0;
                        border-color: currentColor;
                    }

                    .v-text-field__slot {
                        display: inherit;
                    }
                }
            }
        }
    }

    &-result {
        position: absolute;
        top: 4px;
        width: auto;
        left: -16px;
        right: -16px;
        z-index: 8;

        &-wrap {
            position: relative;
            background-color: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 24px;
            padding: 12px;
            padding-top: 56px;

            &-copy {
                overflow-y: scroll;
                max-height: calc(100vh - 200px);
                padding-right: 8px;
            }

            &-meta {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 6px;
            }
        }
    }
}
</style>
